import { css } from 'styled-components';

import layout from '../app/layout';
import ExecutionEnvironment from '../ExecuteEnvironment';

type MediaType = {
  extraSmall: Function;
  small: Function;
  medium: Function;
  large: Function;
  extraLarge: Function;
};

export const isMobile = (): boolean => {
  if (ExecutionEnvironment.isServer) {
    return true;
  }

  return window.innerWidth < 768;
};

export const media: MediaType = Object.keys(layout.responsive).reduce(
  (accumulator, currentValue) => {
    const { type, unit } = layout.responsive[currentValue];

    return {
      ...accumulator,
      [currentValue]: (...style) => css`
        @media (${type}: ${unit}) {
          ${css(...style)}
        }
      `,
    };
  },
  {
    extraSmall: (style) => style,
    small: (style) => style,
    medium: (style) => style,
    large: (style) => style,
    extraLarge: (style) => style,
  },
);
